/**
 * api server
 * 普通数据api
 */
import { getConfig } from './server-url-config/env';
import { post, get } from 'src/utils/request-manager';

let config = getConfig();
let baglogUrl = `${config.apiUrl.bagLog}`;

export async function getBagLogList(param, endpoint) {
  return get(`${baglogUrl}/records?${param}`, { endpoint });
}

export async function getHistoryBagLogList(param, endpoint) {
  return get(`${baglogUrl}/historyRecords?${param}`, { endpoint });
}

export async function getAutoUploadRecord(param, endpoint) {
  return get(`${baglogUrl}/records/robots/${param}:getUploadRecordEnable`, { endpoint });
}

export async function setAutoUploadRecord(sn, param, endpoint) {
  return post(
    `${baglogUrl}/records/robots/${sn}:setUploadRecordEnable`,
    {
      "enable": param
    },
    { endpoint }
  );
}

export async function uploadOrPull(recordId, endpoint) {
  return get(`${baglogUrl}/records/${recordId}:fetch`, { endpoint });
}

export async function downloadBagOrLog(body, endpoint) {
  return get(`${baglogUrl}/records/${body.recordId}:download?region=${body.region}`, { endpoint });
}

export async function multiUploadOrPull(body, endpoint) {
  return post(`${baglogUrl}/records:batchFetch`, body, { endpoint, useOriginalError: false });
}

export async function syncBagOrLog(body, endpoint) {
  return post(`${baglogUrl}/records/${body.recordId}:sync`, { "region": body.region }, { endpoint });
}

export async function downloadRecords(body, endpoint){
  return post(`${baglogUrl}/records:download`, body, { endpoint })
}

export async function SyncBatchRecords(body, endpoint){
  return post(`${baglogUrl}/records:syncBatch`, body, { endpoint })
}

export async function createManifest(body, endpoint) {
  return post(`${baglogUrl}/manifests`, body, { endpoint });
}

export async function getManifests(param, endpoint) {
  return get(`/tempo/v1beta1/aggManifests?${param}`, { endpoint });
}

export async function getManifest(id, queryString, endpoint) {
  return get(`/tempo/v1beta1/aggManifests/${id}/records${queryString}`, { endpoint });
}

export async function getManifestInfo(id, endpoint) {
  return get(`/tempo/v1beta1/manifests/${id}:fetch`, { endpoint });
}

//获取上传信息
export async function getUploadInfo(bussinessCode, params, endpoint) {
  return post(`${baglogUrl}/user/records:batchUpload`, 
    {
      sourceType: "web",
      bussinessCode: bussinessCode,
      records: params
    },
    { endpoint }
  );
}

//查询数据回流计划列表
export async function listPageUploadPlans(body, endpoint) {
  return post(`${baglogUrl}/uploadPlans:listPage`, body, { endpoint });
}

//获取临时下载信息
export async function getDownloadInfo(id, endpoint) {
  return post(`${baglogUrl}/user/records:permission`, 
    {
      recordIds: [id]
    },
    { endpoint }
  );
}

//获取网络信息
export async function getRobotNetworkResource(sn, endpoint) {
  return get(`${baglogUrl}/robots/${sn}:getRobotNetworkResource`, { endpoint });
}

//变更计划状态
export async function setUploadPlanEnableStatus(name, body, endpoint) {
  return post(`${baglogUrl}/${name}:SetUploadPlanEnableStatus`, body, { endpoint });
}

//创建数据回流计划列表
export async function batchCreateUploadPlans(body, endpoint) {
  return post(`${baglogUrl}/uploadPlans:batchCreate`, body, { endpoint });
}

//获取数据回流的文件路径
export async function getSupportTargetPaths(body, endpoint) {
  return get(`${baglogUrl}/supportTargetPaths`, { endpoint });
}

// 获取SN 日志迁移时间节点
// tempo/v1alpha1/records/getEarliestRecordTime
export async function getEarliestRecordTime(body, endpoint) {
  return post(`${baglogUrl}/records/getEarliestRecordTime`, body, {
    endpoint,
  });
}
